import React from 'react'

import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid'
import { useTheme } from '@mui/material/styles'

import { ImageContentProps } from '../../../core/types/Help'

export const BottomImageContent: React.FC<ImageContentProps> = ({
  altImage,
  content,
  hasDivider = true,
  image,
  imageLargeBreakPoint = 12,
  sx,
}) => {
  const theme = useTheme()
  return (
    <React.Fragment>
      <Box sx={{ pb: 48, ...sx }}>
        <Grid container={true} rowSpacing={24}>
          <Grid size={12}>{content}</Grid>
          <Grid
            size={{ xs: 12, sm: 12, md: 12, lg: imageLargeBreakPoint }}
            sx={{
              m: '0 auto',
              [theme.breakpoints.between('sm', 'lg')]: {
                display: 'flex',
                justifyContent: 'center',
              },
              '& img': {
                width: '100%',
                maxWidth: 1176,
                [theme.breakpoints.between('sm', 'lg')]: {
                  width: '75%',
                },
              },
            }}
          >
            <img alt={altImage} src={image} />
          </Grid>
        </Grid>
      </Box>
      {hasDivider && <Divider />}
    </React.Fragment>
  )
}
